// extracted by mini-css-extract-plugin
module.exports = {"overview":"resourceOverview_overview-3fJWU"};